import styled, { css , keyframes} from 'styled-components';
import { rem, em } from 'polished';
import { Heading } from 'elements';
import { HeadingBase } from 'elements/Heading/styled';
import { media, Flex } from 'core/layout';
import { colors, accessibilityBorder, themed } from 'core/theme';
//font-size: ${em(14)};

const slideIn = keyframes`
  from {
    transform: translateY(-100%);
  }

  to {
     transform: translateY(0px);
  }
`;

export const LetterNav = styled.div`
 		&.fixed {
 			animation: ${slideIn} 0.5s cubic-bezier(0, 0.97, 0, 0.99);
			box-shadow: 0 1px 2px 0 rgba(0,0,0,0.07), 0 1px 2px 0 rgba(0,0,0,0.06), 0 1px 3px 0 rgba(0,0,0,0.1);

				display:block;
				width: 100%;
				height:auto;

				position:fixed;
				top:65px;
				left:0;
				z-index: 1;
				
				background-color:${colors.background};
				border-bottom: 1px solid ${colors.hairline};

 				> div {
 						> div {
 								padding-top:0;
 								padding-bottom:0;
 								> div {
 									margin-bottom:0;
 									main {
										display: flex;
										flex-wrap: wrap;
									}
 								}
 						}
 				}
					
					
 				
 		}
 		width: 100%;
 		padding-top:${rem(4)};
 		padding-bottom:${rem(4)};
  	a {
  			display: inline-flex;
			  color:${colors.text};
				padding:${rem(8)} ${rem(8)};
				font-size:${rem(16)};
				font-weight:500;
				text-decoration: none;

				height: 44px;
				width: 28px;

        align-items: center;

        &:hover{
        	color:${colors.primary};
        }

			  &.active {
			  		color:${colors.primary};
			  		font-size:${rem(21)};
			  }
			  &.disabled {
			  		pointer-events:none;
			  		color:${colors.lightText};
			  }
  	}
 
`;

export const LinkList = styled.div`
	> div {
				
				
		> a {
			&:last-of-type {
				margin:0;
				border-bottom: 1px solid ${colors.hairline};
				padding-top:${rem(12)};
				padding-bottom:${rem(12)};
			}
		}
	}
 
`;


export const LinkItem= styled.div`
	 > a {
	 	display:block;
	 	color:${colors.text};
		text-decoration:none;
		font-size:${rem(18)};
		font-weight:500;
		
		${media.tabletSmall`
       font-size:${rem(16)};
    `};


  	

  	> h1 {
  			line-height:1;
  			margin-top:${rem(48)};
  			margin-bottom:${rem(24)};
  			font-size:${rem(34)};
			  color:${colors.primary};
  	}
	 }

 
`;




// WEBPACK FOOTER //
// ./src/pages/Pakalpojumi/styled.js